<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>

        <mat-form-field appearance="fill">
          <mat-label>
            {{'registration from'| translate:['reporting.list-export-document.filter.from',
            translationService.language]}}
          </mat-label>
          <input matInput formControlName="dateFrom" [matDatepicker]="picker1">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <mat-form-field appearance="fill">
          <mat-label>{{'to'| translate:['reporting.list-export-document.filter.to',
            translationService.language]}}
          </mat-label>
          <input matInput formControlName="dateUntil" [matDatepicker]="picker2">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <mat-form-field appearance="fill">
          <mat-label>
            {{'template' | translate: ['reporting.list-export-document.filter.template',
            translationService.language]}}
          </mat-label>
          <mat-select formControlName="template">
            <mat-option *ngFor="let t of templates" value="{{t.id}}">
              {{t.dictionaryKey | translate: [t.dictionaryKey, translationService.language]}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <button (click)="updateList()" [disabled]="isUpdateListDisabled()" mat-stroked-button>
          {{'show'| translate:['reporting.list-export-document.action.show',
          translationService.language]}}</button>

        <sc-content-spacer></sc-content-spacer>

        <button (click)="createExcel()" [disabled]="isCreateDisabled()" mat-flat-button>
          {{'export'| translate:['reporting.list-export-document.action.export',
          translationService.language]}}</button>

      </sc-flex>
    </form>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex-fitting-content [vertical]="true">
    <sc-content-area [fitHeight]="true">
      <sc-scroll-pane>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
              {{'title'| translate:['reporting.list-export-document.table.column.title',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let document"> {{document.title}} </td>
          </ng-container>
          <ng-container matColumnDef="documentDate">
            <th mat-header-cell *matHeaderCellDef>
              {{'date'| translate:['reporting.list-export-document.table.column.documentDate',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let document"> {{document.documentDate}} </td>
          </ng-container>
          <ng-container matColumnDef="template">
            <th mat-header-cell *matHeaderCellDef>
              {{'template'| translate:['reporting.list-export-document.table.column.template',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let document"> {{document.template}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
        </table>
      </sc-scroll-pane>
    </sc-content-area>
  </sc-flex-fitting-content>

</sc-flex>